import { getOccTransport } from "~/common/api/occTransport";
import { getCsrfValue } from "~/common/utils/ApiHelper";

export const submitSchaefflerForm = async (data: Record<string, string>): Promise<void> => {
  const { request, url } = getOccTransport();
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => formData.append(key, value));

  const response = await request(
    url("/contact-form/submit"),
    {
      method: "POST",
      body: formData,
      credentials: "same-origin",
      mode: "cors",
      referrer: "no-referrer",
      redirect: "follow",
      headers: {
        CSRFToken: getCsrfValue(),
      },
    },
    { accountContext: "omit" },
  );

  if (!response.ok) {
    throw new Error("Error submitting form");
  }
};
